export enum ReleaseSource {
  AUTO = 'auto',
  API = 'api',
  GITHUB = 'github'
}

export interface IReleaseGithub {
  repo: string;
  tag: string;
  url: string;
}

export interface IRelease {
  version: string;
  source: ReleaseSource;
  firstSeen?: Date;
  deployedAt?: Date;
  github?: IReleaseGithub;
  notes?: string;
  adoption: number; // fraction 0..1 of sessions in the adoption window
  crashFreeSessions?: number; // fraction 0..1; undefined when the release has no sessions
  newIssues: number;
  regressedIssues: number;
  sessions: number;
}

export interface IReleaseMarker {
  version: string;
  time: Date;
  source: ReleaseSource;
}
